var React = require('react');

function Address (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#54d2df"},[React.createElement("circle",{"cx":"6.783","cy":"6.003","r":"2.563","key":0}),React.createElement("path",{"d":"m13.066 6.783c0 3.47-4.334 11.717-6.283 11.717-1.933 0-6.283-8.247-6.283-11.717a6.283 6.283 0 1 1 12.566 0z","key":1})]));
}

Address.defaultProps = {"height":"19","viewBox":"0 0 13.566 19","width":"13.566"};

module.exports = Address;

Address.default = Address;
